<!-- eslint-disable @intlify/vue-i18n/no-dynamic-keys -->
<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

import signupBg from 'dashboard/assets/images/auth/signup-bg.jpg';

const { t } = useI18n();
const store = useStore();
const route = useRoute();

const uiFlags = useMapGetter('wgptOnboarding/getUIFlags');

const zaynaConfig = {
  logo: '/dashboard/images/onboarding/zayna_logo.svg',
  logoDark: '/dashboard/images/onboarding/zayna_logo_white.svg',
  installationName: 'Zayna',
};

const HEADER_META = {
  wgpt_onboarding: {
    title: 'WGPT_ONBOARDING.WELCOME.TITLE',
    subtitle: 'WGPT_ONBOARDING.WELCOME.SUBTITLE',
  },
  wgpt_onboarding_channels: {
    title: 'WGPT_ONBOARDING.CHANNELS.TITLE',
    subtitle: 'WGPT_ONBOARDING.CHANNELS.SUBTITLE',
  },
  wgpt_onboarding_channels_whatsapp: {
    title: 'WGPT_ONBOARDING.CHANNELS.WHATSAPP.TITLE',
    subtitle: 'WGPT_ONBOARDING.CHANNELS.SUBTITLE',
  },
  wgpt_onboarding_channels_facebook: {
    title: 'WGPT_ONBOARDING.CHANNELS.FACEBOOK.TITLE',
    subtitle: 'WGPT_ONBOARDING.CHANNELS.SUBTITLE',
  },
  wgpt_onboarding_channels_instagram: {
    title: 'WGPT_ONBOARDING.CHANNELS.INSTAGRAM.TITLE',
    subtitle: 'WGPT_ONBOARDING.CHANNELS.SUBTITLE',
  },
  wgpt_onboarding_integrations: {
    title: 'WGPT_ONBOARDING.INTEGRATION.TITLE',
    subtitle: 'WGPT_ONBOARDING.INTEGRATION.SUBTITLE',
  },
};

const headerMeta = computed(() => HEADER_META[route.name] || null);
const headerTitle = computed(() =>
  headerMeta.value ? t(headerMeta.value.title) : null
);
const headerSubtitle = computed(() =>
  headerMeta.value ? t(headerMeta.value.subtitle) : null
);

onMounted(() => {
  store.dispatch('inboxes/get');
  store.dispatch('integrations/get');
});
</script>

<template>
  <div
    class="relative w-full flex-1 flex items-start sm:items-center justify-center bg-cover bg-center bg-no-repeat p-4"
    :style="{ backgroundImage: `url(${signupBg})` }"
  >
    <div
      class="fixed inset-0 bg-n-gray-12/60 dark:bg-n-gray-1/80 backdrop-blur-sm"
    />

    <div
      v-if="uiFlags.isFetching"
      class="relative flex items-center justify-center w-full h-64"
    >
      <span class="i-woot-spinner h-8 w-8 text-white animate-spin" />
    </div>

    <template v-else>
      <div
        class="relative w-full max-w-3xl bg-white dark:bg-n-solid-2 rounded-xl shadow-md outline outline-1 outline-n-container overflow-hidden"
      >
        <div class="px-8 pt-8 pb-6">
          <img
            :src="zaynaConfig.logo"
            :alt="zaynaConfig.installationName"
            class="block h-7 w-auto dark:hidden mb-6"
          />
          <img
            v-if="zaynaConfig.logoDark"
            :src="zaynaConfig.logoDark"
            :alt="zaynaConfig.installationName"
            class="hidden h-7 w-auto dark:block mb-6"
          />

          <template v-if="headerTitle">
            <h1 class="text-2xl font-semibold text-n-slate-12">
              {{ headerTitle }}
            </h1>
            <p class="mt-1 text-sm text-n-slate-11">
              {{ headerSubtitle }}
            </p>
          </template>
        </div>

        <div class="p-8">
          <router-view />
        </div>
      </div>
    </template>
  </div>
</template>
